/* global currentYear, queryString */
import get from 'lodash/get'
import { legendDictionary } from 'bam-node-bdata-charts/utils/legend-dictionary'
import { guff } from 'bam-node-baseball-savant/utils/guff'

const {
    CURRENT_VS_WALLTIMORE,
} = require('bam-node-baseball-savant/constants/walltimore-versions')

export function getSecondaryHeaders(type) {
    if (type === 'distance') {
        return [
            {
                name: '',
                colspan: 3,
                headerClass: 'th-name-header',
            },
            {
                name: 'Variable Extra Distance',
                colspan: 5,
                headerClass: 'th-title-header',
            },
        ]
    }
    if (type === 'distance-all') {
        return [
            {
                name: '',
                colspan: 1,
                headerClass: 'th-name-header',
            },
            {
                name: 'Environmental Extra Distance',
                colspan: 6,
                headerClass: 'th-title-header',
            },
        ]
    }
    if (type === 'distance-venue') {
        return [
            {
                name: '',
                colspan: 1,
                headerClass: 'th-name-header',
            },
            {
                name: `<a href="/leaderboard/statcast-park-factors?type=distance&year=${currentYear}&batSide=&stat=index_wOBA&condition=All&rolling=">Extra Feet of Distance vs. Avg (click here for more)</a>`,
                colspan: 11,
                headerClass: 'th-title-header',
            },
        ]
    }
    return []
}

// eslint-disable-next-line default-param-last
export function getHeaders(type, isMetric = false, data) {
    if (type === 'distance') {
        const highlightColors = [
            '#f5f5f5',
            '#3661AD',
            '#3661AD',
            '#ffffff',
            '#D82129',
            '#D82129',
        ]
        const highlightRange = [0, -10, -10, 0, 10, 10]
        return [
            {
                name: 'Venue',
                field: 'venue_name',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: `<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" onerror="this.onerror='';this.src='/site-core/images/savant-mlb.svg'" />`,
                photoId: 'main_team_id',
            },
            {
                name: 'Venue',
                field: 'href',
                headerClass: 'th-component-header align-left border-right',
                fieldClass: 'tr-data align-left border-right',
            },
            {
                name: 'Total',
                field: 'extra_distance',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
                type: 'number',
            },
            {
                name: 'Temp',
                field: 'temperature_extra_distance',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
                type: 'number',
            },
            {
                name: 'Elev',
                field: 'elevation_extra_distance',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
                type: 'number',
            },
            {
                name: 'Env',
                field: 'environment_extra_distance',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
                type: 'number',
            },
            {
                name: 'Roof',
                field: 'roof_extra_distance',
                headerClass: 'th-component-header align-right border-right',
                fieldClass: 'tr-data align-right border-right',
                highlight: highlightRange,
                highlightColors,
                type: 'number',
            },
            {
                name: 'Avg Temp',
                field: 'avg_temperature',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                type: 'number',
            },
            {
                name: 'Elev',
                field: 'elevation_feet',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                type: 'number',
            },
            {
                name: 'Roof %',
                field: 'avg_roof',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                type: 'number',
            },
            {
                name: 'Day %',
                field: 'avg_daytime',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                type: 'number',
            },
        ]
    }
    if (type === 'distance-all') {
        const highlightColors = [
            '#3661AD',
            '#3661AD',
            '#ffffff',
            '#D82129',
            '#D82129',
        ]

        const headers = [
            {
                name: 'Venue',
                field: 'venue_name',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: `<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" onerror="this.onerror='';this.src='/site-core/images/savant-mlb.svg'" />`,
                photoId: 'main_team_id',
            },
        ]

        let yearOpened = get(data, 'venues[0].year_opened')
        if (!yearOpened || Number(yearOpened) <= 2014) {
            yearOpened = 2015
        } else {
            yearOpened = Number(yearOpened)
        }

        for (let y = currentYear; y >= yearOpened; y--) {
            let border = ``
            if (y === currentYear) {
                border = `border-left`
            }
            if (y === 2016 || y === yearOpened) {
                border = `border-right`
            }

            headers.push({
                name: String(y),
                field: `extra_distance_${y}`,
                headerClass: `th-component-header align-center ${border}`,
                fieldClass: `tr-data align-center ${border}`,
                highlight: [-500, -10, 0, 10, 500],
                highlightColors,
                type: 'number',
            })
        }
        return headers
    }
    if (type === 'venue') {
        const highlightColors = [
            '#f5f5f5',
            '#3661AD',
            '#3661AD',
            '#ffffff',
            '#D82129',
            '#D82129',
        ]
        const headers = [
            {
                name: 'Venue',
                field: 'venue_name',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: `<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" onerror="this.onerror='';this.src='/site-core/images/savant-mlb.svg'" />`,
                photoId: 'main_team_id',
            },
            {
                name: isMetric ? 'Metric' : 'Venue',
                field: isMetric ? 'metric_key' : 'href',
                headerClass: 'th-component-header align-left',
                fieldClass: 'tr-data align-left',
            },
        ]

        let yearOpened = get(data, 'venues[0].year_opened')

        if (!yearOpened || Number(yearOpened) < 1998) {
            yearOpened = 1998
        } else {
            yearOpened = Number(yearOpened)
        }

        for (let y = currentYear; y >= yearOpened; y--) {
            headers.push({
                name: String(y),
                field: `metric_value_${y}`,
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [0, 80, 90, 100, 110, 500],
                highlightColors,
                type: 'number',
            })
        }
        return headers
    }
    if (type === 'year') {
        const highlightColors = [
            '#f5f5f5',
            '#3661AD',
            '#3661AD',
            '#ffffff',
            '#D82129',
            '#D82129',
        ]
        const highlightRange = [0, 80, 90, 100, 110, 300]
        return [
            {
                name: 'Team',
                field: 'name_display_club',
                customSortField: 'name_display_club',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />',
                photoId: 'main_team_id',
            },
            {
                name: 'Venue',
                field: 'href',
                headerClass: 'th-component-header align-left',
                fieldClass: 'tr-data align-left',
            },
            {
                name: 'Year',
                field: 'year_range',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
            },
            {
                name: 'wOBA',
                field: 'index_woba',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'wOBAcon',
                field: 'index_wobacon',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'xwOBAcon',
                field: 'index_xwobacon',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'BACON',
                field: 'index_bacon',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'xBACON',
                field: 'index_xbacon',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'HardHit',
                field: 'index_hardhit',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'R',
                field: 'index_runs',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'OBP',
                field: 'index_obp',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'H',
                field: 'index_hits',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: '1B',
                field: 'index_1b',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: '2B',
                field: 'index_2b',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: '3B',
                field: 'index_3b',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'HR',
                field: 'index_hr',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'BB',
                field: 'index_bb',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'SO',
                field: 'index_so',
                type: 'number',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                highlight: highlightRange,
                highlightColors,
            },
            {
                name: 'PA',
                field: 'n_pa',
                headerClass: 'th-component-header align-right',
                fieldClass: 'tr-data align-right',
                type: 'number',
            },
        ]
    }
    if (type === 'wowy_venue_tracked_hip_h') {
        const highlightColors = [
            '#f5f5f5',
            '#3661AD',
            '#3661AD',
            '#ffffff',
            '#D82129',
            '#D82129',
        ]
        const headers = [
            {
                name: 'Venue',
                field: 'venue_name',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: `<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" onerror="this.onerror='';this.src='/site-core/images/savant-mlb.svg'" />`,
                photoId: 'main_team_id',
            },
            {
                name: isMetric ? 'Metric' : 'Venue',
                field: isMetric ? 'metric_key' : 'href',
                headerClass: 'th-component-header align-left',
                fieldClass: 'tr-data align-left',
            },
        ]

        let yearOpened = get(data, 'venues[0].year_opened')

        if (!yearOpened || Number(yearOpened) < 2015) {
            yearOpened = 2015
        } else {
            yearOpened = Number(yearOpened)
        }

        for (let y = currentYear; y >= yearOpened; y--) {
            headers.push({
                name: String(y),
                field: `metric_value_${y}`,
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                highlight: [0, 80, 90, 100, 110, 500],
                highlightColors,
                type: 'number',
            })
        }
        return headers
    }

    if (type === 'meta') {
        return [
            {
                name: 'Venue',
                field: 'name',
                headerClass: 'th-component-header align-left',
                fieldClass: 'tr-data align-left',
            },
            {
                name: 'City',
                field: 'city',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
            },
            {
                name: 'State',
                field: 'state',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
            },
            {
                name: 'Seats',
                field: 'seats',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                displayFn: (val) => Number(val).toLocaleString(),
            },
            {
                name: 'Turf',
                field: 'turf_type',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                displayFn: (val) => {
                    switch (val) {
                        case 'G':
                            return 'Grass'
                        case 'A':
                            return 'Artificial'
                        default:
                            return val
                    }
                },
            },
            {
                name: 'Opened',
                field: 'year_opened',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                // This is a numeric for whatever reason, so without this shows "1992.0000"
                displayFn: (val) => Math.round(val),
            },
            {
                name: 'LF',
                field: 'left_line',
                type: 'number',
                headerClass: 'th-component-header align-center border-left',
                fieldClass: 'tr-data align-center border-left',
                displayFn: (val) => guff(val, 'venue_fence_distance'),
            },
            {
                name: 'LF/C',
                field: 'left_center',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                displayFn: (val) => guff(val, 'venue_fence_distance'),
            },
            {
                name: 'CF',
                field: 'center',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                displayFn: (val) => guff(val, 'venue_fence_distance'),
            },
            {
                name: 'RF/C',
                field: 'right_center',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                displayFn: (val) => guff(val, 'venue_fence_distance'),
            },
            {
                name: 'RF',
                field: 'right_line',
                type: 'number',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                displayFn: (val) => guff(val, 'venue_fence_distance'),
            },
        ].map((d) => ({ ...d, sortable: false }))
    }

    if (type === 'bal_batter_hrs' || type === 'bal_pitcher_hrs') {
        return [
            {
                name: '',
                field: 'total',
                sortable: false,
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
            },
            {
                name: '',
                sortable: false,
                field:
                    type === 'bal_batter_hrs' ? 'batter_name' : 'pitcher_name',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
            },
        ]
    }
    if (type === 'bal_batter_pitcher_yearly_totals') {
        return [
            {
                name: '',
                field: 'year',
                headerClass: 'th-component-header align-left',
                fieldClass: 'tr-data align-left',
                displayFn: (val) => (val === 1 ? '<i>TOTAL</i>' : val),
            },
            {
                name: `${
                    Number(queryString.version) === CURRENT_VS_WALLTIMORE
                        ? 'Gained'
                        : 'Lost'
                } by<br />BAL Hitters`,
                field: 'bal_batters',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
            },
            {
                name: `${
                    Number(queryString.version) === CURRENT_VS_WALLTIMORE
                        ? 'Added to'
                        : 'Saved for '
                }<br />BAL Pitchers`,
                field: 'bal_pitchers',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
            },
        ]
    }
    if (type === 'bal_homeruns_lost_events') {
        return [
            {
                name: 'Date',
                field: 'game_date',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                displayFn: (val) => val.slice(0, 10),
            },
            {
                name: 'Batter',
                field: 'batter_name',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
            },
            {
                name: 'Batting<br />Team',
                field: 'bat_team_abbrev',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
            },
            {
                name: 'Pitcher',
                field: 'pitcher_name',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
            },
            {
                name: 'Pitching<br />Team',
                field: 'pit_team_abbrev',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
            },
            {
                name: 'Outcome',
                field: 'result',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                type: 'string',
                displayFn: (result) => legendDictionary.events[result],
            },
            {
                name: '',
                field: 'play_id',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center video-col',
                type: 'number',
                sortable: false,
                displayFn: (value, { play_id }) => `
                <a href="/sporty-videos?playId=${play_id}" target="_BLANK">
                    <img src="/site-core/images/video.png" style="margin-right: 4px; width: 25px; height: 13px; cursor: pointer;">
                </a>
                `,
            },
        ]
    }
    return []
}
